import * as React from 'react';
import { useDispatch } from 'react-redux';
import styles from './storyitem.module.scss';
import FileItem from '../FileItem';
import { selectBookmark } from '../../store/Meeting/actions';
import { Bookmark } from '../../store/Story/modal';


const BookmarkItem = ({
    id,
    name,
    files,
    thumbnail
}: Bookmark) => {

    const dispatch = useDispatch();
    const metaData = `${files.length} Files`;
    const onItemSelected = () => {
        dispatch(selectBookmark(id, files.map(c=>{
            return {
                id: c.id,
                storyId: c.permId
            }
        })))
    }
    return (
        <div className={styles.root}>
            <FileItem
                category={''}
                onCheckedChange={() => {}}
                showChecked={false}
                disable={false}
                checked={false}
                onItemClick={onItemSelected}
                metaData={metaData}
                id={id}
                title={name}
                thumbnail={thumbnail} />
        </div>
    )
};

export default BookmarkItem